import { IBaseDialogStoreState, BaseDialogStoreState } from '../baseDialogStoreState';

export interface IEditGroupAccountDialogStoreState extends IBaseDialogStoreState { }

export class EditGroupAccountDialogStoreState extends BaseDialogStoreState implements IEditGroupAccountDialogStoreState {
    constructor() {
        super();
    }
}